import React from "react";
import { Select } from "antd";

const SelectSearch = ({ data, setSelectedDepartment }) => {
  const options = data.map((item) => {
    return {
      value: item,
      label: item,
    };
  });
  console.log(options);
  const onChange = (value) => {
    console.log(`selected ${value}`);
    setSelectedDepartment(value);
  };
  const onSearch = (value) => {
    console.log("search:", value);
  };
  const filterOption = (input, option) =>
    (option?.label ?? "").toLowerCase().includes(input.toLowerCase());
  return (
    <div style={{ marginLeft: "20px" }}>
      <Select
        showSearch
        placeholder="Select department"
        optionFilterProp="children"
        onChange={onChange}
        onSearch={onSearch}
        filterOption={filterOption}
        options={options}
      />
    </div>
  );
};

export default SelectSearch;
